import React, { type FC, type PropsWithChildren } from 'react';

import { Link } from '@lucid/components';

import type { Lucid } from 'types/types';

interface FlexiCtaProps {
  data?: Lucid.Directus.Generated.Links;
  displayAsButton?: boolean;
}

const FlexiCta: FC<PropsWithChildren<FlexiCtaProps>> = ({ data, displayAsButton }) => (
  <Link displayAsButton={displayAsButton} href={data?.final_url} iconAnimation="navigational">
    {data?.default_link_text}
  </Link>
);

export default FlexiCta;
